<div *ngIf="noticesLoading" class="row w-100 h-100">
    <div class="col w-100 my-auto">
        <span class="k-icon k-i-loading kendo-loading-icon"></span>
    </div>
</div>
<div *ngIf="!noticesLoading && notice !== undefined && notice !== null" class="h-100">
    <div
        [className]="(notice.priority  === 'HIGH' ? 'urgent-notice row h-100 montserrat' : 'notice row h-100 montserrat')">
        <div class="col-1 my-auto p-0 m-0 text-center" style="width:10%;">
            <i *ngIf="notices.length > 1" class="fas fa-arrow-left mr-1 pointer" (click)="previous()"></i>
        </div>
        <div class="col-10 my-auto p-0 m-0" style="width:80%;">
            <div class="row w-100">
                <div class="col text-center pt-2 pb-2">
                    {{notice.text}}
                    <button *ngIf="notice.canDismiss"
                        class="btn btn-outline-dark custom-button border border-secondary ml-4"
                        (click)="confirmDismissNotice(notice.id)">
                        <span class="text-uppercase">&nbsp;{{'DISMISS'}}</span>
                    </button>
                </div>
            </div>
            <div class="row w-100 text-center" *ngIf="notices.length > 1">
                <div class="col">
                    <span *ngFor="let pointNotice of notices; let i = index"
                        [className]="(pointNotice === notice ? 'dot p-1 pointer my-auto' : 'dot-empty p-1 pointer my-auto')"
                        (click)="loadNotice(i)">
                    </span>
                </div>
            </div>
        </div>
        <div class="col-1 my-auto p-0 m-0 text-center" style="width:10%;">
            <i *ngIf="notices.length > 1" class="fas fa-arrow-right mr-1 pointer" (click)="next()"></i>
        </div>
    </div>
</div>
<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="dismissConfirmationOpened"
    (close)="dismissNotice(false)" [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DISMISS-NOTICE' | translate }}</p>
    <span class="k-font-weight-bold">{{notice.text}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="dismissNotice(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="dismissNotice(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>